module.exports = __webpack_public_path__ + "static/media/close-button.890a4786.svg";